import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { ROUTES_NAMES } from './Layout';

interface MisPodcastsRouteProps {
    children: React.ReactNode;
}

/**
 * Route wrapper for Mis Podcasts product pages.
 * Allows access for:
 * - Platform admins (role === 'admin')
 * - Users whose company has 'mispodcasts' (company-level plan), or per-user list when that mode is enabled
 */
const MisPodcastsRoute: React.FC<MisPodcastsRouteProps> = ({ children }) => {
    const { isAuthenticated, hasProductAccess, getDefaultRoute } = useAuth();
    const navigate = useNavigate();

    if (!isAuthenticated) {
        return <Navigate to={ROUTES_NAMES.AUTH} replace />;
    }

    if (!hasProductAccess('mispodcasts')) {
        const defaultRoute = getDefaultRoute();

        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    backgroundColor: '#ffffff',
                    p: 3,
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        maxWidth: 450,
                        textAlign: 'center',
                        borderRadius: 2,
                    }}
                >
                    <LockIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                    <Typography variant="h5" gutterBottom fontWeight="bold">
                        Mis Podcasts no disponible
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        No tienes acceso al producto Mis Podcasts.
                    </Typography>
                    {defaultRoute !== '/auth' && (
                        <Button
                            variant="contained"
                            onClick={() => navigate(defaultRoute)}
                            sx={{ mt: 1 }}
                        >
                            Ir a inicio
                        </Button>
                    )}
                </Paper>
            </Box>
        );
    }

    return <>{children}</>;
};

export default MisPodcastsRoute;
